import { captureException, withErrorBoundary } from '@sentry/react'
import { createFileRoute, notFound } from '@tanstack/react-router'
import { z } from 'zod'

import { withFallback } from '@/lib/searchParams'
import { SentryErrorPage } from '@/pages/error/SentryErrorPage'
import { SupportAgentPage } from '@/pages/support/SupportAgentPage'

const supportSearchZod = z.object({
  filter: withFallback(z.enum(['toHandle', 'waiting', 'valian', 'open', 'settled']), 'toHandle').optional(),
  escouade: withFallback(z.enum(['all', 'me', 'none']), 'all').optional(),
  q: z.string().optional(),
  n: z.number().int().optional(),
})

export const Route = createFileRoute('/soutien/')({
  beforeLoad: ({ context: { auth } }) => {
    if (auth.supportRole === null) {
      throw notFound()
    }
  },
  component: withErrorBoundary(SupportAgentPage, {
    fallback: SentryErrorPage,
    beforeCapture: (scope) => scope.setTag('route', Route.fullPath),
  }),
  validateSearch: supportSearchZod,
  onCatch: (error) => {
    captureException(error, { tags: { route: Route.fullPath } })
  },
})
